export default {
      id: "camera-online-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "img/icons.svg#camera-online",
      toString: function () {
        return this.url;
      }
    }